import { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { getUserRoles, isAdminUserSelector } from '../../redux/slices/users/usersSlice';

export const RootRedirect = (): ReactElement => {
  const isAdminUser = useSelector(isAdminUserSelector);
  const roles = useSelector(getUserRoles);

  if (isAdminUser) {
    return <Navigate to="/admin/organizations/organizations" />;
  }
  // Contractors only have access to the field-service app; sending them to the
  // dashboard would bounce them straight back here (redirect loop).
  if (roles?.includes('Contractor')) {
    return <Navigate to="/field-service" />;
  }
  return <Navigate to="/activity/dashboard/summary" />;
};
